export const getShowedMessage = (state) => state.audit?.showMessage;
export const getIdRevert = (state) => state.audit?.idRevert;
export const getAudits = (state) => state.audit?.audits;
export const getAuditTableData = (state) => state.audit?.auditTableData;
